import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any) => ({
  root: css`
    min-width: 120px;
  `,
}));

export const useButtonSigninStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
